export default class InformationModal {
    static readonly ID_PREFIX = 'information_modal-'

    id: number

    title: string

    content: string

    begin: Date

    end: Date

    lvl: number

    constructor({
        id,
        title,
        content,
        begin,
        end,
        level,
    }: {
        id: number
        title: string
        content: string
        begin: string
        end: string
        level: number
    }) {
        this.id = id
        this.title = title
        this.content = content
        this.begin = new Date(begin)
        this.end = new Date(end)
        this.lvl = level
    }

    getCookieId(): string {
        return `${InformationModal.ID_PREFIX}${this.id}`
    }
}
